module.exports = __webpack_public_path__ + "static/slide2-1dece23904de14fe3c9616d12cef51f1.jpg";